export default Object.freeze([
  'Кыргыз',
  'Русский',
  'Казах',
  'Узбек',
  'Таджик',
  'Другое',
])
